// extracted by mini-css-extract-plugin
export default {"hollow_dots_spinner":"style_hollow_dots_spinner__KcAEO","dot":"style_dot__gruiq","hollow_dots_spinner-animation":"style_hollow_dots_spinner-animation__DgJOJ"};